// Import components to register custom elements
import { Modal } from "../../web-components/native_components/modal";
import { Button } from "../../web-components/native_components/button";

// Ensure components are registered
void Modal;
void Button;

interface ModalComponent extends HTMLElement {
  open(): void;
  close(): void;
}

export function initPage() {
  const modal = document.querySelector<ModalComponent>(
    "modal-component#revenue-disclosure-modal",
  );
  const trigger = document.querySelector<HTMLElement>(
    "button-component#revenue-disclosure-trigger",
  );

  if (!modal || !trigger) return;

  trigger.addEventListener("click", () => {
    modal.open();
  });
}
